import Item from '../containers/Item.js';
import Error404 from '../containers/Error-404.js';
import AdvancedSearch from '../containers/AdvancedSearch.js';
import SimpleSearchResults from '../containers/SimpleSearchResults.js';
import CharacterAbout from '../containers/CharacterAbout.js';
import CharacterHeadings from '../containers/CharacterHeadings.js';
import CharacterHeadingsDetails from '../containers/CharacterHeadingsDetails.js';
import MainPage from '../containers/MainPage.js';
import AboutPbl from '../containers/AboutPbl.js';
import News from '../containers/News.js';
import NewsItem from '../containers/NewsItem.js';
import Collections from '../containers/Collections.js';
import Login from '../containers/Login.js';

import {Redirect} from 'react-router-dom';

export default [
    {
        id : 'MainPage',
        path : '/',
        exact : true,
        component : MainPage
    },
    // search results
    {
        id : 'SimpleSearchResults',
        path : '/results',
        component : SimpleSearchResults
    },
    {
        id : 'Login',
        path : '/login',
        component : Login
    },
    // results item (records, cards)
    {
        id : 'Item',
        path : '/item/:type/:id',
        component : Item
    },
    // adv search form
    {
        id : 'AdvancedSearch',
        path : '/advanced-search',
        component : AdvancedSearch
    },
    // adv search results
    {
        id : 'AdvancedSearchResults',
        path : '/advanced-results',
        component : SimpleSearchResults
    },
    // records
    {
        id : 'records',
        path : '/records',
        component : Redirect,
        exact: true,
        to: '/records/about'
    },
    {
        id : 'recordsAbout',
        path : '/records/about',
        component : CharacterAbout
    },
    {
        id : 'recordsSearch',
        path : '/records/search',
        component : SimpleSearchResults
    },
    // files
    {
        id : 'files',
        path : '/files',
        component : Redirect,
        exact: true,
        to: '/files/about'
    },
    {
        id : 'filesAbout',
        path : '/files/about',
        component : CharacterAbout
    },
    {
        id : 'filesSearch',
        path : '/files/search',
        component : SimpleSearchResults
    },
    // headings
    {
        id : 'headings',
        path : '/headings',
        component : Redirect,
        exact: true,
        to: '/headings/about'
    },
    {
      id : 'headingsDetails',
      path : '/headings/about/details',
      exact: true,
      component: CharacterHeadingsDetails
    },
    {
        id : 'headingsAbout',
        path : '/headings/about',
        exact: false,
        component: CharacterHeadings
    },
    // collections
    {
        id : 'collections',
        path : '/collections',
        component : Redirect,
        exact: true,
        to: '/collections/about'
    },
    {
        id : 'collectionsAboutId',
        path : '/collections/about/1945',
        component : Redirect,
        exact: true,
        to: '/collections/about'
    },
    {
        id : 'collectionsAboutIdEn',
        path : '/collections/about/1977',
        component : Redirect,
        exact: true,
        to: '/collections/about'
    },
    {
        id : 'collectionsAbout',
        path : '/collections/about',
        exact: true,
        component: Collections
    },
    {
        id : 'collectionsAboutItem',
        path : '/collections/about/:id',
        exact: true,
        component: Collections
    },
    // abotut pbl
    {
        id : 'aboutPbl',
        path : '/about',
        component : Redirect,
        exact: true,
        to: '/about/what-is'
    },
    {
        id : 'about',
        path : '/about/:type',
        exact: true,
        component : AboutPbl
    },
    {
        id: 'AboutPblItem',
        path: '/about/:type/:id',
        exact: true,
        component : AboutPbl
    },
    // news
    {
        id : 'news',
        path : '/news',
        component : Redirect,
        exact: true,
        to: '/news/all'
    },
    {
        id : 'news',
        path : '/news/:type',
        exact: true,
        component : News
    },
    {
        id: 'NewsItem',
        path: '/news/:type/:id',
        component : NewsItem
    },
    // not found
    {
        id : 'error',
        component : Error404
    }
];



// WEBPACK FOOTER //
// ./src/scripts/Routes.js